export default __webpack_public_path__ + "static/media/VolunteeringFallbackIcon.939e799d.svg";